import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { marketTrends } from '../data/mockData';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const MarketSnapshot = () => {
  const data = marketTrends;

  const barOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        backgroundColor: 'rgba(30, 41, 59, 0.95)',
        titleColor: '#f8fafc',
        bodyColor: '#cbd5e1',
        borderColor: 'rgba(59, 130, 246, 0.3)',
        borderWidth: 1,
        padding: 12,
        cornerRadius: 8,
        callbacks: {
          label: (context) => `${context.parsed.y.toLocaleString()} MT`
        }
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        },
        ticks: {
          color: '#64748b',
          font: {
            family: "'IBM Plex Sans', sans-serif",
            size: 11
          }
        }
      },
      y: {
        grid: {
          color: 'rgba(255, 255, 255, 0.05)',
          drawBorder: false
        },
        ticks: {
          color: '#64748b',
          font: {
            family: "'IBM Plex Sans', sans-serif",
            size: 11
          },
          callback: (value) => `${(value / 1000).toFixed(0)}k`
        }
      }
    }
  };

  return (
    <div className="market-snapshot">
      <div className="chart-card">
        <div className="chart-header">
          <h4 className="chart-title">India Imports</h4>
          <span className="chart-badge">2024 YTD</span>
        </div>
        <div className="chart-container">
          <Bar data={data.importData} options={barOptions} />
        </div>
      </div>

      <style jsx>{`
        .market-snapshot {
          display: flex;
          flex-direction: column;
          gap: var(--space-lg);
        }

        .chart-card {
          background: rgba(255, 255, 255, 0.03);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: var(--radius-lg);
          padding: var(--space-md);
        }

        .chart-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: var(--space-md);
        }

        .chart-title {
          font-family: var(--font-display);
          font-size: var(--font-sm);
          font-weight: 600;
          color: var(--color-neutral-50);
        }

        .chart-badge {
          font-size: var(--font-xs);
          padding: 2px var(--space-sm);
          background: rgba(59, 130, 246, 0.15);
          color: var(--color-accent-400);
          border-radius: var(--radius-sm);
        }

        .chart-container {
          height: 180px;
        }
      `}</style>
    </div>
  );
};

export default MarketSnapshot;
